module.exports = __webpack_public_path__ + "static/media/face.65ea8657.jpeg";